import React from 'react';
import { NamedLink } from '../../components';
import { stringify } from '../../util/urlHelpers';
import Banner from './banerCentralStock.png';
import css from './LandingPage.css';

const SectionCentralStock = () => {
  return (
    <div className={css.centralStockWrapper}>
      <img src={Banner} />
      <div>
        <h2>Jak działa Decathlon Rent z&nbsp;dostawą?</h2>
        <div>
          <h3><span>1.</span> Znajdź swój produkt z oferty dostawy</h3>
          <p>Wszystkie produkty z dostawą znajdziesz <NamedLink name="SearchPage" className={css.here} to={{search: stringify({providerId: '602cee2b-4d0f-4cbd-b0ac-abaa8db60ba2'})}}>tutaj</NamedLink></p>
        </div>
        <div>
          <h3><span>2.</span> Wybierz sposób dostawy i zarezerwuj on-line</h3>
          <p>Możesz zamówić sprzęt bezpośrednio do domu lub do wybranego sklepu Decathlon</p>
        </div>
        <div>
          <h3><span>3.</span> Odbierz produkt</h3>
          <p>Czekaj na kuriera lub odbierz w wybranym sklepie</p>
        </div>
        <div>
          <h3><span>4.</span> Zwróć produkt – wybierz wygodny sposób</h3>
          <ul>
            <li><strong>Zamówimy kuriera</strong> po odbiór (następnego dnia roboczego po zakończeniu rezerwacji)</li>
            <li>Możesz też dostarczyć produkt do wybranego <strong>punktu FedEx</strong> (link do punktów otrzymasz po rezerwacji)</li>
            <li>Jeśli odbierałeś w sklepie, zwróć sprzęt <strong>w tej samej lokalizacji</strong></li>
          </ul>
        </div>
        <NamedLink name="SearchPage" className={css.centralStockBtn} to={{search: stringify({providerId: '602cee2b-4d0f-4cbd-b0ac-abaa8db60ba2'})}}>Zobacz ofertę z dostawą</NamedLink>
      </div>
    </div>
  );
}

export default SectionCentralStock;
